import { writable, readable, derived, get } from 'svelte/store';

function persistent(name, _default) {
	const getItem = name => localStorage[name] && JSON.parse(localStorage[name]);
	const setItem = (name, val) => [null, undefined, false].includes(val) ?
										localStorage.removeItem(name) :
										localStorage.setItem(name, JSON.stringify(val));

	if (_default != undefined && getItem(name) == undefined) {
		setItem(name, _default);
	}
	const {set, subscribe, update} = writable(getItem(name));
	subscribe(val => {
		setItem(name, val);
		return getItem(name);
	});
	return {
		subscribe,
		update,
		get: () => getItem(name),
		merge: val => set({...getItem(name), ...val}),
		reset: () => set(_default)
	};
}

export const api_init = writable(null);
export const title = writable('');
export const user = writable(null);
export const status = writable('offline');
export const version = writable(null);

export const auth = persistent('BA_AUTH', {access_token: null, access_token_expires: null, refresh_token: null});
export const current_time = readable(0, function start(set) {
	const interval = setInterval(() => {
		if (get(api_init))
			set(Date.now()/1000);
	}, 3000);

	return function stop() {
		clearInterval(interval);
	};
});

export function token_refresh_needed(current_time, auth) {
	const t = (current_time-15)
	return auth.access_token_expires != null && t > auth.access_token_expires && auth.refresh_token
}

export const token_refresh_is_due = derived(
	[current_time, auth],
	([$current_time, $auth]) => token_refresh_needed($current_time, $auth)
);

export function logout() {
	user.set(null);
	status.set('offline');
	version.set(null);

	auth.reset();
}

export function createUrlStore(ssrUrl) {
	// Ideally a bundler constant so that it's tree-shakable
	if (typeof window === 'undefined') {
		const { subscribe } = writable(ssrUrl);
		return { subscribe }
	}

	const href = writable(window.location.href.replace(/\/$/, ''));

	const originalPushState = history.pushState;
	const originalReplaceState = history.replaceState;

	const updateHref = () => href.set(window.location.href.replace(/\/$/, ''));

	history.pushState = function () {
		originalPushState.apply(this, arguments);
		updateHref();
	}

	history.replaceState = function () {
		originalReplaceState.apply(this, arguments);
		updateHref();
	}

	window.addEventListener('popstate', updateHref);
	window.addEventListener('hashchange', updateHref);

	return derived(href, ($href) => new URL($href));
}

export const goto = loc => {
	history.pushState(loc, null, loc);
}

export const dataUrlFromFile = file => {
	let reader = new FileReader();
	return new Promise(function(resolve, reject) {
		reader.readAsDataURL(file);
		reader.onload = e => {
			resolve(e.target.result);
		};
		reader.onerror = e => {
			reject(e);
		}
	});
}

export const encodedFileInfoFromFile = async file => {
	const dataurl = await dataUrlFromFile(file);
	return [file.name,
					dataurl.split(':').at(-1).split(',').at(-1),
					file.lastModified, file.type];
}
